<script lang="ts">
    import { useLocaleContext, useLocaleISOContext, usePropertiesContext } from '$lib/context';
    import { buildFilterURL } from '$lib/util/searchUtil';
    import { getIdByOptionName } from '$lib/util/util';
    import { onMount } from 'svelte';

    const lang = useLocaleContext();
    const isoCode = useLocaleISOContext();
    const properties = usePropertiesContext();

    export let isProductPage = false;

    let scrollY: number;
    let lastScroll = 0;
    let scrollThreshold = 50;
    let hideOnScrollDrown = true;
    let innerHeight: number;
    let innerWidth: number;

    $: navFixed = scrollY > innerHeight - (innerWidth < 1024 ? 122 + 54 : 66 + 54) || isProductPage;

    // TODO: implement swiper and clean up this mess
    let ticketFilter: any = {};
    ticketFilter[`category.${isoCode}`] = ['Ticket'];

    let packageFilter: any = {};
    packageFilter[`category.${isoCode}`] = [isoCode === 'de-DE' ? 'Paket' : 'Package'];

    const categories = [
        { name: 'Alle', filter: '' },
        { name: 'Riesling', filter: buildFilterURL({ 'type.id': [getIdByOptionName(properties.type, 'Riesling')] }) },
        {
            name: 'Burgunder',
            filter: buildFilterURL({ 'type.id': [getIdByOptionName(properties.type, 'Spätburgunder')] })
        },
        { name: 'VV-Line', filter: buildFilterURL({ 'line.id': [getIdByOptionName(properties.line, 'VV')] }) },
        {
            name: 'Frucht & Edelsüß',
            filter: buildFilterURL({ 'taste.id': [getIdByOptionName(properties.taste, 'fruchtsüß')] })
        },
        { name: 'Prestige', filter: buildFilterURL({ 'line.id': [getIdByOptionName(properties.line, 'prestige')] }) },
        { name: 'Tickets', filter: buildFilterURL(ticketFilter) },
        { name: 'Weinpakete', filter: buildFilterURL(packageFilter) }
    ];

    let isDown = false;
    let startX: number;
    let scrollLeft: number;
    let slider: HTMLElement;
    let isDragging = false;

    function handleMouseDown(e: MouseEvent) {
        isDown = true;
        isDragging = false;
        slider.style.cursor = 'grabbing';
        startX = e.pageX - slider.offsetLeft;
        scrollLeft = slider.scrollLeft;
    }

    function handleMouseLeave() {
        isDown = false;
        slider.style.cursor = 'grab';
    }

    function handleMouseUp(e: MouseEvent) {
        isDown = false;
        slider.style.cursor = 'grab';

        if (isDragging) {
            e.preventDefault();
            e.stopPropagation();
        }
    }

    function handleMouseMove(e: MouseEvent) {
        if (!isDown) return;
        e.preventDefault();
        isDragging = true;
        const x = e.pageX - slider.offsetLeft;
        const walk = x - startX;
        slider.scrollLeft = scrollLeft - walk;
    }

    function handleClick(e: MouseEvent) {
        if (isDragging) {
            e.preventDefault();
            e.stopPropagation();
        }
    }

    onMount(() => {
        const handleScroll = () => {
            if (!navFixed) return;

            const currentScroll = scrollY;

            if (Math.abs(currentScroll - lastScroll) < scrollThreshold) {
                // Ignore small scroll movements
                return;
            }

            hideOnScrollDrown = currentScroll <= lastScroll;

            lastScroll = currentScroll; // Update the last scroll position
        };

        window.addEventListener('scroll', handleScroll);

        // Cleanup the event listener when the component is destroyed
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    });
</script>

<!-- TODO: add correct properties with production data -->
<svelte:window bind:scrollY bind:innerHeight bind:innerWidth />
<nav
    class="text-grey w-full top-0 tracking-widest z-30 text-sm font-jost sticky left-0 uppercase bg-black transition-transform duration-150 {!navFixed ||
    hideOnScrollDrown
        ? 'translate-y-0'
        : '-translate-y-14'}"
    class:sticky-navbar={navFixed}
>
    <div class="h-[3.375rem] w-full flex justify-center relative">
        <!-- svelte-ignore a11y-no-static-element-interactions -->
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <div
            bind:this={slider}
            class="w-full max-w-screen-2xl overflow-x-scroll flex items-center h-full gap-6 justify-between no-scrollbar text-nowrap cursor-grab select-none px-5"
            on:mousedown={handleMouseDown}
            on:mouseleave={handleMouseLeave}
            on:mouseup={handleMouseUp}
            on:mousemove={handleMouseMove}
            on:click={handleClick}
        >
            {#each categories as { name, filter }, index}
                <a
                    class="hover:text-neutral-300 px-5 transition-colors duration-300 text-[0.813rem]"
                    href="/{lang}/search{filter ? '?filter=' + filter : ''}">{name}</a
                >
                {#if index !== categories.length - 1}
                    <div class="h-6 w-[1px] bg-darkestgold flex-shrink-0" />
                {/if}
            {/each}
        </div>
        <div
            class="absolute xl:hidden right-0 top-0 h-full aspect-square pointer-events-none bg-gradient-to-r from-transparent to-black"
        />
    </div>
</nav>

<style lang="postcss">
    .sticky-navbar {
        @apply fixed top-[7.625rem] lg:top-[4.125rem];
    }
</style>
